var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	9970: {
		fallback: () => (() => (__webpack_require__(1148))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.15.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@bolt/foundations",

	},
	6499: {
		fallback: () => (() => (__webpack_require__(1547))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "graphql",

	},
	6510: {
		fallback: () => (() => (__webpack_require__(961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	562: {
		fallback: () => (() => (__webpack_require__(6540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	1124: {
		fallback: () => (() => (__webpack_require__(6758))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.9.11",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@apollo/client",

	},
	8877: {
		fallback: () => (() => (__webpack_require__(6616))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.5.6",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@bolt/components",

	},
	6552: {
		fallback: () => (__webpack_require__.e(1976).then(() => (() => (__webpack_require__(9595))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.10.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/authentication",

	},
	6521: {
		fallback: () => (() => (__webpack_require__(4876))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.100.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@ue/commons",

	},
	5242: {
		fallback: () => (__webpack_require__.e(1553).then(() => (() => (__webpack_require__(1553))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.30.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/events",

	},
	903: {
		fallback: () => (() => (__webpack_require__(5941))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.4.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@ue/experience-context",

	},
	7934: {
		fallback: () => (() => (__webpack_require__(6763))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.6.4",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@ue/i18n",

	},
	7438: {
		fallback: () => (() => (__webpack_require__(6068))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.1.5",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@ue/navigation",

	},
	608: {
		fallback: () => (__webpack_require__.e(9880).then(() => (() => (__webpack_require__(9880))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.9.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "apollo-link-rest",

	},
	980: {
		fallback: () => (__webpack_require__.e(7971).then(() => (() => (__webpack_require__(7971))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "date-fns-tz",

	},
	7158: {
		fallback: () => (() => (__webpack_require__(2648))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.30.4",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	1339: {
		fallback: () => (__webpack_require__.e(3221).then(() => (() => (__webpack_require__(3221))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "uuid",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [9970,6499,6510,562];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"3524": [
		9970,
		6499,
		6510,
		562
	],
	"5350": [
		1124,
		8877,
		6552,
		6521,
		5242,
		903,
		7934,
		7438,
		608,
		980,
		7158,
		1339
	],
	"9595": [
		1124,
		6521
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}